module.exports = "https://bicocca-network.servercdn.it/static/img/close.svg?574854becd9fe32f84dffcc8ac39ea85";